// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"600":"9d54c351","605":"1dd8037e","991":"73d50eee","2134":"972fbaf9","6188":"9d54c351","6347":"7f2853b0","6773":"34928591"}[chunkId] + ".chunk.css";
};